import configJSON from '@/data/config/config.default.json'
import { fetchAppConfig } from './featchAppConfig'

export type Config = typeof configJSON

export const config = await fetchAppConfig<Config>()

